var util = require('lib/util');

/**
 * @module create-element
 * @private
 */

/**
 * Parse CSS selector and returns object with tag name, ID and array of class names.
 * 
 * @private
 * @param {string} selector 
 * @returns {object} 
 */
function parseSelector(selector) {
    var token,
        classList = [],
        id,
        tag,
        re = /(^[^.#]+|\.[^.#]+|#[^.#]+)/g;
    while (re.exec(selector)) {
        token = RegExp.$1;
        switch (token.substring(0, 1)) {
            case '.':
                classList.push(token.substr(1));
                break;
            case '#':
                id = token.substr(1);
                break;
            default:
                tag = token;
        }
    }
    return {
        id: id,
        classList: classList,
        tag: tag || 'div'
    };
}


/**
 * Create HTML elements from string.
 *
 * @param {string} syntax
 * @returns {HTMLElement[]}
 */
function createElementsFromHTML(syntax) {
    var div = document.createElement('div');
    div.innerHTML = syntax;
    return Array.prototype.slice.call(div.childNodes);
}


/**
 * Creates HTML element with given tag name, list of attributes and array of children.
 *
 * @param {string} name
 * @param {object} [options]
 * @param {*} [content]
 * @returns {HTMLElement}
 */
function createElement(name, options, content) {
    var el,
        parsed = {},
        isArray = function (o) { return util.isObject(o) && util.isFunction(o.forEach); },
        hasOptions = util.isObject(options) && !isArray(options) && !(options instanceof Node);

    parsed = parseSelector(name);
    el = document.createElement(parsed.tag);

    function addChild(child) {
        if (util.isString(child)) {
            el.append.apply(el, createElementsFromHTML(child));
        } else if (isArray(child)) {
            child.forEach(addChild);
        } else {
            el.append(child || '');
        }
    }

    Array.prototype.slice.call(arguments, hasOptions ? 2 : 1).forEach(addChild);

    if (hasOptions) {
        for (var key in options) {
            if (!util.isUndefined(options[key])) {
                if (options.hasOwnProperty(key)) {
                    if (key === 'dataset' && util.isObject(options[key])) {
                        for (var datakey in options.dataset) {
                            if (!util.isUndefined(options.dataset[datakey])) {
                                if (options.dataset.hasOwnProperty(datakey)) {
                                    el.dataset[datakey] = options.dataset[datakey];
                                }
                            }
                        }
                    }
                    el[key] = options[key];
                } else {
                    el.setAttribute(key, options[key]);
                }
            }
        }
    }
    if (parsed.id) {
        el.id = parsed.id;
    }
    parsed.classList
        .map(function (token) {
            return token.replace(/\s/g, '_');
        })
        .forEach(function (cl) {
            el.classList.add(cl);
        });
    return el;
}

module.exports = {
    parseSelector: parseSelector,
    createElement: createElement,
    createElementsFromHTML: createElementsFromHTML
};
